export default "__VITE_ASSET__$HoOBxli__"